import { atom } from 'recoil';


const iconosDeLista = atom({
    key: "iconosDeLista",
    default: []
  });
  export default iconosDeLista;